// Dictionnaire anglais — langue de référence.
//
// Il sert aussi de FILET : toute clé absente d'une autre langue retombe
// ici (voir lib/i18n.js). C'est donc le seul dictionnaire qui doit être
// complet en permanence.
import landing from './landing'
import app from './app'
import legal from './legal'

const en = { ...landing, ...app, legal }

export default en
